import applications from 'locales/dental/en/application/application.json'
import news from 'locales/dental/en/application/news.json'
import promotions from 'locales/dental/en/application/promotion.json'
import manageWeb from 'locales/dental/en/application/manageWeb.json'

export const ApplicationEN = {
  ...applications,
  ...news,
  ...promotions,
  ...manageWeb
}
